import Ajax from "@/api/ajax";
export default{
    //返利记录
    receiptGoods(params) {
        return Ajax.post("/Home/receiptGoods", params);
    },
    // 是否拉黑卖家
    blockSeller(params) {
        return Ajax.post("/Home/seller/block", params);
    },
    // 拉黑卖家
    isBlockSeller(param){
        return Ajax.post("/Home/seller/check-blocked", param);
    }

}